export default "__VITE_ASSET__DPmDMrBS__"